<template>
  <div id="gear-wrap">
    <h2 v-if="!forOverview">Gear</h2>
    <CharacterMainGear :coin="coin" :weight="weight" :maxWeight="maxWeight" @changeCoin="changeCoin" />
    <WeightedSimpleList :items="inventory" v-on:change="updateGear"/>
    <SaveButtons v-if="!forOverview" @clear="clearGear"/>
  </div>
</template>

<script>
import CharacterMainGear from './CharacterMainGear.vue';
import WeightedSimpleList from '../../util/WeightedSimpleList.vue';
import SaveButtons from '../../util/SaveButtons';

// Coin, Starting Gear, Inventory
export default {
  name: 'Gear',
  props: ['forOverview'],
  components: { 
    CharacterMainGear, 
    WeightedSimpleList, 
    SaveButtons 
  },
  created() {
    this.calculateWeight();
  }, 
  methods: {
    changeCoin: function(val) {
      this.coin = val;
    },
    updateGear: function() {
      this.calculateWeight();
    },
    calculateWeight: function() {
      this.weight = 0;
      this.inventory.forEach(item => {
        item.weights.forEach(weight => {
          if (weight.name.toLowerCase() === 'weight') {
            this.weight += Number(weight.value);
          }
        });
      });
    },
    clearGear: function() {
      this.$store.dispatch('clearCharacterGear');
    }
  },
  computed: {
    coin: {
      get() {
        return this.$store.state.character.coin;
      },
      set(val) {
        this.$store.commit('updateCharacterCoin', Number(val));
      }
    },
    weight: {
      get() {
        return this.$store.state.character.weight;
      },
      set(val) {
        this.$store.commit('updateCharacterWeight', val);
      }
    },
    maxWeight: {
      get() {
        if (this.$store?.state?.character?.class) {
          return this.$store.state.default.classSepcs[this.$store.state.character.class].maxWeight;
        } else {
          return 0;
        }
      }
    },
    inventory: {
      get() {
        return this.$store.state.character.inventory;
      },
      set(val) {
        this.$store.commit('updateCharacterInventory', val);
      }
    },
  }
} 
</script>

<style lang="css">
  #gear-wrap {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 20px;
  }
</style>